<template>
    <div class="tags-box">
        <tagsAll v-if="showTagsAll" />
        <tagInfo :key="tagId" v-else />
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Watch } from "vue-property-decorator";
    import tagsAll from "./tagsAll.vue";
    import tagInfo from "../en/tagInfo.vue";

    @Component({
        components: {
            tagsAll,
            tagInfo,
        },
    })
    export default class tagsBox extends Vue {
        get showTagsAll() {
            return this.$store.state.showTagsAll;
        }
        get pcLang() {
            return this.$store.state.pcLang;
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get tagId() {
            return this.$store.state.tagId;
        }
        @Watch("userInfo.user_id")
        onLoginChanged(val) {
            if (!this.isPC || !val) return;
            this.$store.dispatch("getIds");
        }
        @Watch("lang")
        changeLang() {
            this.getSpecialTags();
        }
        getSpecialTags() {
            let lang = this.isPC ? this.pcLang : this.lang;
            this.$store.dispatch("getSpecialTags", lang);
        }
        mounted() {
            this.getSpecialTags();
            this.isPC && (<any>window).$qt.jsCallWebUIDisplay();
            const url = new URLSearchParams(location.search.slice(1));
            const tags = url.get("tags");
            if (!tags) return;
            if (tags == "all") {
                this.$store.commit("toAlbumAll");
            } else {
                this.$store.commit("toAlbumID", parseInt(tags));
            }
        }
    }
</script>
<style lang="less" scoped>
    .tags-box {
        height: 100%;
        overflow: auto;
        &::-webkit-scrollbar {
            width: 8px;
            height: 6px;
            pointer-events: none;
            background: var(--backgroudColor);
        }
        &::-webkit-scrollbar-thumb {
            background: var(--scrollBackground);
            border-radius: 4px;
        }
    }
</style>
